import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from './store';
import { createTournament } from './store/tournamentSlice';
import { resetClock, setCurrentRound } from './store/clockSlice';
import { TournamentDashboard } from './pages/TournamentDashboard';
import { FloatingClock } from './components/Clock';
import { cleanupSessionSync } from './store/sessionMiddleware';
import { Spade } from 'lucide-react';

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const tournament = useSelector((state: RootState) => state.tournament.current);
  const { clockPosition } = useSelector((state: RootState) => state.settings);

  // Create a default tournament on first load
  useEffect(() => {
    if (!tournament) {
      dispatch(createTournament());
    }
  }, [tournament, dispatch]);

  // Sync clock with tournament when tournament is created/loaded
  useEffect(() => {
    if (tournament && tournament.rounds.length > 0) {
      const firstRound = tournament.rounds[0];
      dispatch(setCurrentRound(tournament.state.currentRound));
      dispatch(resetClock(tournament.state.secondsRemaining || firstRound.minutes * 60));
    }
  }, [tournament?.id, dispatch]);

  // Cleanup session sync on unmount
  useEffect(() => {
    return () => {
      cleanupSessionSync();
    };
  }, []);

  if (!tournament) {
    return (
      <div className="min-h-screen bg-poker-green flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin-slow mb-4">
            <Spade size={48} className="text-poker-gold mx-auto" />
          </div>
          <div className="text-white text-xl font-display">
            Loading Tournament Director...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <TournamentDashboard />
      <FloatingClock visible={clockPosition === 'floating'} />
    </div>
  );
}

export default App;